import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuGlobalParameter,
  SeuGlobalParameterApi,
  SeuGlobalParameterBase,
  SeuGlobalParameterBaseApi,
} from '@seu-types';

export const globalParameterConverter: SeuApiConverter<
  SeuGlobalParameter,
  SeuGlobalParameterApi
> = {
  fromApi: (input) => {
    const base = globalParameterBaseConverter.fromApi(input);
    return {
      title: base.title,
      description: base.description,
      inputs: base.inputs,
      id: String(input.id),
      isDefault: input.defaultGlobalParameterSet,
    };
  },
  toApi: (input) => {
    const base = globalParameterBaseConverter.toApi(input);
    return {
      title: base.title,
      description: base.description,
      inputs: base.inputs,
      id: Number(input.id),
      defaultGlobalParameterSet: input.isDefault,
    };
  },
};

export const globalParameterBaseConverter: SeuApiConverter<
  SeuGlobalParameterBase,
  SeuGlobalParameterBaseApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.fromApi(configInput);
      }),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
    };
  },
};
